import "@/styles/tailwind.css";
import { defineSetupVue3 } from "@histoire/plugin-vue";

// eslint-disable-next-line @typescript-eslint/no-empty-function
export default defineSetupVue3(() => {});
